//./plugins/posthog.js
import posthog from "posthog-js";
export default {
  install(app) {
    // Only initialize PostHog in production
    if (process.env.NODE_ENV === 'production') {
      app.config.globalProperties.$posthog = posthog.init(
        process.env.VUE_APP_POSTHOG_KEY,
        {
          api_host: process.env.VUE_APP_POSTHOG_HOST,
        }
      );
    } else {
      // Create a mock PostHog instance for development
      app.config.globalProperties.$posthog = {
        identify: () => {},
        capture: () => {},
        // Add other PostHog methods you use as empty functions
      };
    }
  },
};

